/**
 * @param {Date | string} referenceTime - The date/time to compare against
 * @param {string} mode - 'past' | 'future' | 'after' | 'before'
 * @param {boolean} isDateOnly - If true, compare date only (ignores time)
 */
export const manageFilteredDateTime = (referenceTime, mode = 'past', isDateOnly = false) => {

    return (selected) => {
        const ref = new Date(referenceTime);
        const sel = new Date(selected);

        if (isDateOnly) {
            ref.setHours(0, 0, 0, 0);
            sel.setHours(0, 0, 0, 0);
        }

        if (mode === 'thisWeek') {
            const day = ref.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
            const diffToMonday = ref.getDate() - day + (day === 0 ? -6 : 1);
            const monday = new Date(ref.setDate(diffToMonday));
            const sunday = new Date(monday);
            sunday.setDate(monday.getDate() + 6);

            monday.setHours(0, 0, 0, 0);
            sunday.setHours(23, 59, 59, 999);

            return sel >= monday && sel <= sunday;
        }

        switch (mode) {
            case 'past':
                return sel <= ref;
            case 'future':
                return sel >= ref;
            case 'after':
                return sel.getTime() >= ref.getTime();
            case 'before':
                return sel.getTime() <= ref.getTime();
            default:
                return true;
        }
    };
};


/**
 * Combines a date string and a time string into a single Date object.
 * Safely handles missing or invalid inputs.
 *
 * @param {string | Date} dateString - The date part (e.g. "2025-04-07")
 * @param {string} timeString - The time part (e.g. "15:45:00")
 * @returns {Date|null} A combined Date object or null if invalid
 */
export const combineDateTime = (dateString, timeString) => {
    if (!dateString || !timeString) return null;

    const [hours, minutes, seconds] = timeString.split(":").map(Number);

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;

    date.setHours(hours || 0);
    date.setMinutes(minutes || 0);
    date.setSeconds(seconds || 0);
    date.setMilliseconds(0);

    return date;
};
